export default __webpack_public_path__ + "static/media/bg-plan-top.43d204a9.png";